import React from "react";
import { Link } from "react-router-dom";
import { BRAND, NAV_ITEMS } from "../lib/content";
import BrandMark from "./BrandMark";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--bjc-border)] bg-[var(--bjc-bg)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <BrandMark height={120} className="mb-10 -ml-3" />
            <h3 className="font-serif-display text-3xl md:text-5xl leading-[1.05] text-[var(--bjc-text)] max-w-[18ch]">
              Compliance must be effective, not merely documented.
            </h3>
            <p className="mt-8 text-[var(--bjc-text-muted)] max-w-md leading-relaxed">
              A specialist global advisory firm focused on AML, financial crime risk, and
              regulatory defence.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="bjc-overline mb-6">Navigation</div>
            <ul className="space-y-3">
              {NAV_ITEMS.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-nav-${n.label.toLowerCase()}`}
                    className="text-[var(--bjc-text)] hover:text-[var(--bjc-gold)] transition-colors text-sm"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="bjc-overline mb-6">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${BRAND.email}`}
                  className="text-[var(--bjc-text)] hover:text-[var(--bjc-gold)] transition-colors"
                >
                  {BRAND.email}
                </a>
              </li>
              <li className="text-[var(--bjc-text-muted)]">India · Middle East · Asia-Pacific</li>
              <li className="pt-4">
                <Link
                  to="/contact"
                  data-testid="footer-cta"
                  className="bjc-link"
                >
                  Speak With Us →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[var(--bjc-border)] flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs tracking-[0.16em] uppercase text-[var(--bjc-text-faint)]">
            © {year} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs tracking-[0.16em] uppercase text-[var(--bjc-text-faint)]">
            Specialist Global Advisory · AML · Financial Crime · Regulatory Defence
          </p>
        </div>
      </div>
    </footer>
  );
}
